import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number": {
      "column": {
        "default": null,
        "name": "phone_number",
        "null": false,
        "type": "string"
      },
      "name": "phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "primary": {
      "column": {
        "default": "0",
        "name": "primary",
        "null": false,
        "type": "boolean"
      },
      "name": "primary",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactPhoneNumber",
  "collectionKey": "contact_phone_numbers",
  "collectionName": "contact_phone_numbers",
  "i18nKey": "contact_phone_number",
  "camelizedLower": "contactPhoneNumber",
  "name": "ContactPhoneNumber",
  "nameDasherized": "contact-phone-number",
  "pluralName": "contact_phone_numbers",
  "ransackable_associations": [
    {
      "className": "ContactPhoneNumber::Audit",
      "collectionName": "contact_phone_number_audits",
      "foreignKey": "contact_phone_number_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ContactPhoneNumberAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "ContactPhoneNumber::Audit",
      "collectionName": "contact_phone_number_audits",
      "foreignKey": "contact_phone_number_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContactPhoneNumberAudit",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "phone_number",
      "column": {
        "default": null,
        "name": "phone_number",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "primary",
      "column": {
        "default": "0",
        "name": "primary",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "contact_phone_number",
  "primaryKey": "id"
}

/** Frontend model for ContactPhoneNumber. */
class ContactPhoneNumber extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  primary() {
    return this.readAttributeUnderscore("primary")
  }

  /** @returns {boolean} */
  hasPrimary() {
    const value = this.primary()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const modelClass = modelClassRequire("Contact")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "contact", model: this, modelClass},
      {ransack}
    )
  }
}

export default ContactPhoneNumber
